import React from 'react';
import PropTypes from 'prop-types';
import { withLocalize, Translate } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { formatObligedPerson } from './propertyCzUtils';

import './propertyCz.scss';

class PropertyCzNotes extends React.Component {
    static propTypes = {
        notes: PropTypes.object,
        restrictions: PropTypes.bool
    };

    static defaultProps = {
        restrictions: false
    };

    render() {
        const notes = this.props.notes;
        const headKey = this.props.restrictions ? "PropertyCz.Report.OD.OwnershipRestriction" : "PropertyCz.Report.OD.OtherNotes";
        const noDataKey = this.props.restrictions ? "PropertyCz.Report.OD.NoRestrictions" : "PropertyCz.Report.OD.NoNotes";

        if (isNullOrUndefined(notes) || !notes.any) {
            return (
                <div className="cuzk-notes">
                    <div className="bold"><Translate id={headKey} /></div>
                    <div className="cuzk-note"><Translate id={noDataKey} /></div>
                </div>
            );
        }

        const allNotes = [...notes.toSubject, ...notes.toParcel, ...notes.toBuilding, ...notes.toFlat, ...notes.other];
        return (
            <div className="cuzk-notes">
                <div className="bold"><Translate id={headKey} /></div>
                {allNotes.map((n, i) => <div key={i} className="cuzk-note">
                    <div>{n.name}</div>
                    <div style={{ whiteSpace: "pre-wrap" }}>{n.description}</div>
                    <div>
                        {formatObligedPerson(n.obligedPerson, this.props.translate("PropertyCz.Search.CompanyId"), this.props.translate("PropertyCz.Report.OD.ObligedPersons"))}
                    </div>
                </div>)}
            </div>
        );
    }
}

export default withLocalize(PropertyCzNotes);